import { Component } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { MatToolbar } from "@angular/material/toolbar";
import { ArcusBreadcrumbComponent } from "../arcus-breadcrumb/arcus-breadcrumb.component";
import { MatIconButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

@Component({
    selector: "anonymous-toolbar",
    templateUrl: "./anonymous-toolbar.component.html",
    styleUrl: "./anonymous-toolbar.component.scss",
    imports: [MatToolbar, RouterLink, ArcusBreadcrumbComponent, MatIconButton, MatTooltip, FaIconComponent],
})
export class AnonymousToolbarComponent {
    constructor(private router: Router) {}

    login() {
        this.router.navigate(["/login"]);
    }
}
